import { soundToPlay, stopAllSounds } from '../../../mechanics/sounds/sound'
import { fightSlice } from '../../../store/reducers/FightReducer'
import { sceneSlice } from '../../../store/reducers/SceneReducer'
import { useAppDispatch, useAppSelector } from '../../../store/store'
import ImgWithFallback from '../../ui/ImgWithFallback'
import "./ExplorationScene.scss"
import ExplorationSceneDirections from './ExplorationSceneDirections'
import ExplorationSceneIsComplete from './ExplorationSceneIsComplete'

export default function ExplorationScene() {
    const dispatch = useAppDispatch()
    const { clearDeadEnemies } = fightSlice.actions
    const { setScene, resetPassedLocationLevels } = sceneSlice.actions
    const locations = useAppSelector(state => state.SceneReducer.locations)
    const locationsIndex = useAppSelector(state => state.SceneReducer.currentLocation)
    const currentLocation = locations.getLocationsSet()[locationsIndex]

    function handleClick() {
        dispatch(clearDeadEnemies())
        dispatch(setScene(currentLocation.getLocationScene()))
        currentLocation.passLevel()
    }

    function exitExploration() {
        stopAllSounds()
        soundToPlay("mainMusic")
        currentLocation.setIsComplete(true)
        currentLocation.resetLevels()
        dispatch(resetPassedLocationLevels(0))
        dispatch(setScene("main"))
    }

    return (
        <div className="exploration-scene">
            <div className="exploration-scene__backimg">
                <ImgWithFallback
                    src={currentLocation.getBackground().webp}
                    fallbackSrc={currentLocation.getBackground().img} />
            </div>
            <div className="exploration-scene__wrapper">
                {
                    currentLocation.getPassedLevels() === currentLocation.getMaxLevels() ?
                        <ExplorationSceneIsComplete exitExploration={exitExploration} />
                        :
                        <ExplorationSceneDirections handleClick={handleClick} />
                }
            </div>
        </div>
    )
}
